$(document).ready(function () {
    $(window).resize(function () {
    // This will fire each time the window is resized:
    if ($(window).width() >= 1024) {
        $('#mi-corpo-product-header-img').attr('height', '590');
        $('#mi-corpo-product-header-img').attr('width', '620');


    }
 else {
        $('#mi-corpo-product-header-img').attr('height', '200');
        $('#mi-corpo-product-header-img').attr('width', '200');

    }
    }).resize(); // This will simulate a resize to trigger the initial run.
});
